import { Fetch, removeIdentityToken } from 'lib';

type RequestResponses = {};

const signOut = async () => {
  const responses = await Fetch<RequestResponses>({
    url: 'identity/signOut',
    method: 'PATCH',
  });

  await removeIdentityToken();

  return responses;
};

export { signOut };
